import { Cell } from "@tanstack/react-table";

interface IProps {
  cell: Cell<any, unknown>;
}

//* flexRender rend une fonction `cell` comme un type de composant. Les pages
//* recréent leurs colonnes à chaque rendu : chaque rafraîchissement (temps réel,
//* retour sur l'onglet) démontait alors toutes les cellules — écoute d'un
//* enregistrement coupée, saisie en cours perdue. Appelée depuis ce composant au
//* type fixe, la cellule garde son sous-arbre monté.
const TableCellContent = ({ cell }: IProps) => {
  const render = cell.column.columnDef.cell;
  return <>{typeof render === "function" ? render(cell.getContext()) : render}</>;
};

export default TableCellContent;
